// Your featureFlags.js file
import Vue from "vue";
import { get } from "@/services/request";
import { featureFlagsAPI } from "@/services/api";

const state = {
  // store feature flags here.
  // for example: { "FLAG": true } means feature named FLAG is enabled.
  flags: {}
};

const getters = {
  // Get flag state by feature programmatic name (defined by server as enum constant--Feature.java)
  getFlag: state => feature => {
    return state.flags[feature];
  }
};

const mutations = {
  // Set flag state
  setFlag(state, { feature, enabled }) {
    Vue.set(state.flags, feature, enabled);
  }
};

const actions = {
  async fetchFlags({ commit }) {
    get(featureFlagsAPI)
      .then(response => {
        if (response && response.data) {
          // Set each flag in state
          for (let flag of response.data) {
            commit("setFlag", flag);
          }
        }
      })
      .catch(() => {
        console.log("Unable to fetch feature flags.");
      });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
